import React, { createContext, FC, PropsWithChildren, useContext } from 'react';

interface ProgrammProps {
	foerderRichtlinieDetails: any;
	organisationDetails: any;
	handleShowFreischaltungsPopUp: (antragsFormulas: string, foerderProgramm: any) => void;
	handleShowSkizzeUeberspringenPopUp: (_foerderProgramm: any) => void;
	handleCreateApplication: (foerderProgrammID: number, foerderProgrammDetails: any, antragsDetails: any) => void;
}

const FoerderProgrammContext = createContext<PropsWithChildren<ProgrammProps>>({
	foerderRichtlinieDetails: {},
	organisationDetails: {},
	handleShowFreischaltungsPopUp: (_antragsFormular: string, _foerderProgramm: any) => {},
	handleShowSkizzeUeberspringenPopUp: (_foerderProgramm: any) => {},
	handleCreateApplication: (_foerderProgrammID: number, _foerderProgrammDetails: any, _antragsDetails: any) => {},
});
const FoerderProgrammContextProvider: FC<PropsWithChildren<ProgrammProps>> = ({
	children,
	foerderRichtlinieDetails = {},
	organisationDetails = {},
	handleShowFreischaltungsPopUp = (_antragsFormular: string, _foerderProgramm: any) => {},
	handleShowSkizzeUeberspringenPopUp = (_foerderProgramm: any) => {},
	handleCreateApplication = (_foerderProgrammID: number, _foerderProgrammDetails: any, _antragsDetails: any) => {},
}) => {
	return (
		<FoerderProgrammContext.Provider
			value={{
				foerderRichtlinieDetails,
				organisationDetails,
				handleCreateApplication,
				handleShowFreischaltungsPopUp,
				handleShowSkizzeUeberspringenPopUp,
			}}
		>
			{children}
		</FoerderProgrammContext.Provider>
	);
};
export default FoerderProgrammContextProvider;

function useFoerderProgramm() {
	const context = useContext(FoerderProgrammContext);
	if (context === undefined) {
		throw new Error('useFoerderProgramm must be used within a FoerderProgrammProvider');
	}
	return context;
}
export { useFoerderProgramm };
